export const METRICS_CONSENT_AUTO_CORRECTION_STATE_NAME = 'metricsConsentAutoCorrection';

export interface MetricsConsentAutoCorrectionState {
  status: 'not-configured' | 'off' | 'on';
  buttonIcon: 'auto_fix_normal' | 'auto_fix_off';
  enabled: boolean;
  loading: boolean;
  processing: boolean;
}

export interface MetricsConsentAutoCorrectionButtonState {
  disabled: boolean;
  loading: boolean;
}
